module.exports = __webpack_public_path__ + "media/Video 25c.c4be5e69.mp4";